<div class="container">
    @if (!isBuildingOverview) {
        <div class="editorItem">
            <div class="label">Building</div>
            @if (selectedBuilding && isReadOnly && showInternalNavigator) {
                <app-internal-navigator
                    [path]="routeToSingle"
                    [label]="selectedBuilding.name"
                    [isActive]="selectedBuilding.isActive"
                ></app-internal-navigator>
            } @else {
                <div class="inputContainer">
                    <app-type-ahead-buildings
                        [isReadOnly]="isReadOnly"
                        [displaySelected]="displaySelectedBuilding"
                        [selectedBuilding]="selectedBuilding"
                        (selectedBuildingChange)="onSelectedBuilding($event)"
                        [error]="!isValid"
                        [isActive]="true"
                        [path]="routeToSingle"
                    >
                    </app-type-ahead-buildings>
                    <app-validation-error-message
                        [show]="!isValid"
                        [errors]="validationErrors"
                    ></app-validation-error-message>
                </div>
            }
        </div>
    }
    <app-location-details
        [location]="selectedBuilding"
        [(line2)]="$any(bindContext).line2"
        (line2Change)="valueChange.emit()"
        [isReadOnly]="isReadOnly"
    >
    </app-location-details>
    @if (selectedBuilding && selectedBuilding.latitude && selectedBuilding.longitude) {
        <div class="map">
            <app-static-map
                [latitude]="selectedBuilding.latitude"
                [longitude]="selectedBuilding.longitude"
            ></app-static-map>
        </div>
    }
</div>
